import { render, staticRenderFns } from "./ReportsList.vue?vue&type=template&id=6c82e22c&scoped=true"
import script from "./ReportsList.vue?vue&type=script&lang=js"
export * from "./ReportsList.vue?vue&type=script&lang=js"
import style0 from "./ReportsList.vue?vue&type=style&index=0&id=6c82e22c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c82e22c",
  null
  
)

export default component.exports